<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll"
    @check-none="checkNone"
    @set-selected-row="setSelectedRow"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as PRODUCT_CATEGORY_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'ProductCategoryTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'code',
          label: this.$t('Code'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'code'
        },
        {
          key: 'name',
          label: this.$t('Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'description',
          label: this.$t('Description'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'description'
        },
        {
          key: 'type_of_sale',
          label: this.$t('Type of sale'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'type_of_sale_name'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'code', 'name', 'description', 'type_of_sale']
    }
  },
  computed: {
    ...mapGetters({
      selectAll: PRODUCT_CATEGORY_TYPES.GENERIC.product.productcategory.LIST.GETTERS.selectAll,
      selectedList: PRODUCT_CATEGORY_TYPES.GENERIC.product.productcategory.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return hasPerm('product_productcategory_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: PRODUCT_CATEGORY_TYPES.GENERIC.product.productcategory.LIST.MUTATIONS.setList,
      setSelectedList:
        PRODUCT_CATEGORY_TYPES.GENERIC.product.productcategory.LIST.MUTATIONS.setSelectedList,
      setSelectAll: PRODUCT_CATEGORY_TYPES.GENERIC.product.productcategory.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...PRODUCT_CATEGORY_TYPES.GENERIC.product.productcategory.LIST.ACTIONS
    })
  }
}
</script>
